import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { CommentModel } from '@/features/crm/types';

async function get_inadimplence_by_cities(year): Promise<CommentModel[]> {
  const api = await getApi();
  const { data } = await api.get(`financeiro/get_inadimplence_by_cities/`, {
    params: { year },
  });
  return data;
}

type QueryFnType = typeof get_inadimplence_by_cities;

function useInadimplenceByCities(year) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['get_inadimplence_by_cities', year],
    queryFn: () => get_inadimplence_by_cities(year),
  });
}

export { get_inadimplence_by_cities, useInadimplenceByCities };
